import { AppStateModel } from './../../models/state-models/state.model';
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, Observer } from 'rxjs';
import { Token } from '../../services/token/index'
import { map, mergeMap, first } from 'rxjs/operators';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { PUBLIC_ROUTE } from 'src/app/constants/routes.constants';


@Injectable({
  providedIn: 'root'
})
export class LayoutGuard implements CanActivate, CanLoad {
  constructor(
    private $router: Router,
    private $profile: ProfileService,
    private $token: Token,
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): any {
    return this.handler();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): any {
    return this.handler();
  }
  private handler(): any {
    let observable :any= this.$profile.changes;
    if (!this.$profile.isProfileLoaded) {
      observable = this.$profile.queryProfile();
    }
     return observable.pipe(first(), map((profile) => {

      if (!profile && !this.$token.hasValue) {
      this.$router.navigateByUrl(PUBLIC_ROUTE.url);
      return false;
      }

      return true;

    }));
  }
}
